



















































































































import {
  defineComponent,
  ref,
  Ref,
  onMounted,
  computed
} from "@vue/composition-api";
import { useGetters, useActions } from "vuex-composition-helpers";
import useFetcher from "@use/useFetcher";
import ProjectModel from "@/ts/models/projectClass";
import EventModel from "@/ts/models/eventClass";
import CaldateModel from "@/ts/models/caldateClass";
import ProjentCard from "@c/molecules/card/ProjentCard.vue";
import moment from "moment";

export default defineComponent({
  name: "Calendar",

  components: {
    ProjentCard
  },

  setup(props, { root, refs }) {
    var calendar = ref({
      move: (arg: any) => {},
      prev: () => {},
      next: () => {},
      parsedValue: { month: 0 }
    });

    var focus = ref("");
    var type = ref("month");
    var selectedCaldate = ref({}) as Ref<CaldateModel>;
    var selectedChild = ref({});
    var selectedElement = ref(null);
    var selectedOpen = ref(false);

    const place_id = parseInt(root.$route.params.id);

    var { entity: rawCaldates, loading } = useFetcher(
      "caldate/GET_CALDATES_BY_PLACE",
      {action_param:place_id}
    );

    var caldates: any = computed(() => {
      var arr = [] as Array<CaldateModel>;
      if (rawCaldates.value) {
        rawCaldates.value.forEach((caldate: CaldateModel) => {
          caldate.start = moment
            .utc(caldate.start)
            .tz(moment.tz.guess())
            .format("YYYY-MM-DD HH:mm:ss");
          caldate.end = moment
            .utc(caldate.end)
            .tz(moment.tz.guess())
            .format("YYYY-MM-DD HH:mm:ss");
          arr.push(caldate);
        });
      }
      return arr;
    });

    onMounted(() => {
      calendar.value.move(0);
    });

    const typeToLabel = {
      month: root.$t("month"),
      week: root.$t("week"),
      day: root.$t("day")
    };

    const getCaldateColor = (caldate: CaldateModel) => {
      return caldate.color;
    };

    const viewDay = ({ date }: any) => {
      focus.value = date;
      type.value = "day";
    };

    const setToday = () => {
      focus.value = "";
    };

    const prev = () => {
      calendar.value.prev();
    };

    const next = () => {
      calendar.value.next();
    };

    const showCaldate = ({ nativeEvent, event }: any) => {
      const open = () => {
        const classes: any = {
          project: ProjectModel,
          event: EventModel
        };

        function dynamicClass(name: string) {
          return classes[name];
        }

        selectedCaldate.value = event;
        selectedElement.value = nativeEvent.target;

        const entity_model = dynamicClass(selectedCaldate.value.child_type);
        selectedChild.value = new entity_model(selectedCaldate.value.child);

        setTimeout(() => {
          selectedOpen.value = true;
        }, 10);
      };

      if (selectedOpen.value) {
        selectedOpen.value = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    };

    return {
      focus,
      typeToLabel,
      type,
      selectedCaldate,
      selectedElement,
      selectedChild,
      selectedOpen,
      caldates,
      loading,
      viewDay,
      setToday,
      getCaldateColor,
      prev,
      next,
      showCaldate,
      calendar
    };
  }
});
